import styled from "@emotion/styled";

export const BackupContainer = styled.div`
  padding: 30px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const BackupSection = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.main[9]};
  background-color: ${({ theme }) => theme.colors.settingsSectionBg};
  border-radius: 6px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 400px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 2px 6px;
`;

export const RestrictedMessage = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.red[5]};
  background-color: ${({ theme }) => theme.colors.red[0]};
  border-radius: 6px;
  padding: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 500px;
  box-shadow: rgba(0, 0, 0, 0.24) 0px 2px 6px;
`;

export const Divider = styled.div`
  width: 100%;
  border-bottom: 1px solid lightgray;
  margin: 15px 0 15px 0;
`;
